import { render } from "./InviteUserModalComponent.vue?vue&type=template&id=5f52b2fb&scoped=true"
import script from "./InviteUserModalComponent.vue?vue&type=script&lang=js"
export * from "./InviteUserModalComponent.vue?vue&type=script&lang=js"

import "./InviteUserModalComponent.vue?vue&type=style&index=0&id=5f52b2fb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f52b2fb"]])

export default __exports__